import styles from './FooterTrustLogos.module.scss'
import ThemeImage from '@/components/elements/media/ThemeImage/ThemeImage'
import { Col } from 'react-bootstrap'

const trustLogos = [
  {
    href: 'https://tourcert.org/',
    src: 'images/logos/logo-tourcert-white.png',
    alt: 'TourCert Logo',
    height: 43,
    name: 'TourCert',
  },
  {
    href: 'https://www.garantiefonds.ch/',
    src: 'images/logos/logo-reisegarantie-white.png',
    alt: 'Reisegarantie Logo',
    height: 38,
    name: 'Reisegarantie',
  },
  {
    href: 'https://www.srv.ch/',
    src: 'images/logos/logo-srv.png',
    alt: 'SRV Logo',
    height: 37,
    name: 'SRV',
  },
  {
    href: 'https://www.astag.ch/',
    src: 'images/logos/logo-astag.png',
    alt: 'ASTAG Logo',
    height: 36,
    name: 'ASTAG',
  },
]

const FooterTrustLogos = () => {
  return (
    <>
      {trustLogos.map((logo, index) => (
        <Col key={index} xs={12} md={4} lg={2} className={`${styles.root} align-self-center justify-content-center`}>
          <a target="_blank" href={logo.href} rel="noreferrer" data-tr-click="footer:trust_icon:click" data-tr-trust_icon_name={logo.name}>
            <ThemeImage src={logo.src} height={logo.height} alt={logo.alt} theme="kultour" />
          </a>
        </Col>
      ))}
    </>
  )
}

export default FooterTrustLogos
